module.exports = __webpack_public_path__ + "static/media/carthree.dbd0bf9c.png";